
export default {
  name: 'CustomerTitle',
  props: {
    /**
     * Title attributes
     * @see elements/text-heading
     */
    attributes: {
      type: Object,
      default() {
        return {
          level: 1,
        };
      },
    },
    /**
     * Title label
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * Link href and label
     */
    link: {
      type: Object,
      default: undefined,
      validator(val) {
        return 'href' in val && 'label' in val;
      },
    },
  },
};
